export default {
  OpportunityContext: "iglu:com.torrelabs/OpportunityContext/jsonschema/1-0-0",
  UserContext: "iglu:com.torrelabs/User/jsonschema/2-0-0"
} as { [key: string]: string };
